<template>
  <div id="support">
    <section class="section pt-1 bg-white">
      <div class="container">
        <h1 class="media mb-5">
          <div class="avatar-sm mr-3">
            <span class="avatar-title rounded-circle bg-soft-warning text-warning font-size-28">
              <i class="bx bx-support"></i>
            </span>
          </div>
          {{ $t("help.contact") }}
        </h1>

        <div class="row">
          <div class="col-lg-4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <template v-slot:header>
                <h5 class="my-0 text-primary"><i class="mdi mdi-phone mr-3"></i>{{ $t("help.contact-and-support.title") }}</h5>
              </template>

              <h5 class="card-title mt-0">
                <a href="tel:05523688863" class="text-dark">0552 368 88 63</a>
              </h5>
              <p class="card-text">
                {{ $t("help.contact-and-support.phone-text") }}
              </p>
            </b-card>
          </div>

          <div class="col-lg-4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <template v-slot:header>
                <h5 class="my-0 text-primary"><i class="bx bx-building-house mr-3"></i>{{ $t("help.contact-and-support.address") }}</h5>
              </template>
              <h5 class="card-title mt-0">Tune Soft Teknoloji Ticaret A.Ş.</h5>

              <p class="card-text">
                Göztepe Mahallesi Santral Sok. No:20
                <br />
                PK: 34815 Beykoz, İstanbul – Turkey
              </p>
            </b-card>
          </div>

          <div class="col-lg-4">
            <b-card header-class="bg-transparent border-primary" class="border border-primary">
              <template v-slot:header>
                <h5 class="my-0 text-primary">
                  <i class="bx bx-world mr-3"></i>
                  {{ $t("help.contact-and-support.digital-address") }}
                </h5>
              </template>
              <h5 class="card-title mt-0">
                <a href="mailto:destek@tunesoft.com.tr" class="text-dark">destek@tunesoft.com.tr</a>
              </h5>
              <h5 class="card-title mt-0">
                <a href="https://tunesoft.com.tr/" class="text-dark" target="_blank">https://tunesoft.com.tr</a>
              </h5>

              <h5 class="card-title mt-0">
                <a href="https://blog.tunesoft.com.tr/" class="text-dark" target="_blank">https://blog.tunesoft.com.tr</a>
              </h5>
            </b-card>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-lg-6 offset-3">
            <h3 class="mt-4 mb-4">{{ $t("help.contact-and-support.form") }}</h3>
            <b-form>
              <b-form-group :label="$t('common.name-surname')" label-cols-sm="3">
                <b-form-input
                  type="text"
                  v-model="support.name"
                  :class="{
                    'is-invalid': $v.support.name.$error,
                    'is-valid': !$v.support.name.$error,
                  }"
                />
                <div v-if="$v.support.name.$error" class="invalid-feedback">
                  <span v-if="!$v.support.name.required">
                    {{ $t("help.contact-and-support.required") }}
                  </span>
                  <span v-if="!$v.support.name.maxLength">
                    {{ $t("help.contact-and-support.max-50") }}
                  </span>
                  <span v-if="!$v.support.name.minLength">
                    {{ $t("help.contact-and-support.min-5") }}
                  </span>
                </div>
              </b-form-group>

              <b-form-group :label="$t('application.phone')" label-cols-sm="3">
                <b-form-input
                  type="text"
                  v-model="support.phone"
                  placeholder="055xxxxxxxx"
                  :class="{
                    'is-invalid': $v.support.phone.$error,
                    'is-valid': !$v.support.phone.$error,
                  }"
                />
                <div v-if="$v.support.phone.$error" class="invalid-feedback">
                  {{ $t("help.contact-and-support.phone-required") }}
                </div>
              </b-form-group>

              <b-form-group class="mb-4" :label="$t('application.email')" label-cols-sm="3">
                <b-form-input
                  type="email"
                  v-model="support.email"
                  :class="{
                    'is-invalid': $v.support.email.$error,
                    'is-valid': !$v.support.email.$error,
                  }"
                />
                <div v-if="$v.support.email.$error" class="invalid-feedback">
                  {{ $t("help.contact-and-support.email-required") }}
                </div>
              </b-form-group>

              <b-form-group :label="$t('common.firm')" label-cols-sm="3">
                <b-form-input
                  type="text"
                  v-model="support.firm"
                  :class="{
                    'is-invalid': $v.support.firm.$error,
                    'is-valid': !$v.support.firm.$error,
                  }"
                />
                <div v-if="$v.support.firm.$error" class="invalid-feedback">
                  {{ $t("help.contact-and-support.company-required") }}
                </div>
              </b-form-group>

              <b-form-group :label="$t('help.contact-and-support.message')" label-cols-sm="3">
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="support.message"
                  :class="{
                    'is-invalid': $v.support.message.$error,
                    'is-valid': !$v.support.message.$error,
                  }"
                ></textarea>
                <div v-if="$v.support.message.$error" class="invalid-feedback">
                  {{ $t("help.contact-and-support.required-min-max") }}
                </div>
              </b-form-group>

              <div v-if="reference">
                <b-alert show variant="success">
                  <b>
                    <u> {{ reference }}</u>
                  </b>
                  {{ $t("help.contact-and-support.reference") }}
                </b-alert>
              </div>

              <div v-if="!reference" class="form-group row justify-content-end">
                <div class="col-sm-9">
                  <div>
                    <b-button variant="primary" class="float-right" :disabled="$v.support.$error" @click="send">
                      <i class="bx bx-envelope align-middle font-size-16"></i>
                      {{ $t("help.contact-and-support.submit") }}
                    </b-button>
                  </div>
                </div>
              </div>

              <b-alert show variant="info">
                {{ $t("help.contact-and-support.protect-data") }}

                <a href="javascript:;" v-b-modal.modal1>
                  <b>{{ $t("help.contact-and-support.enlightenment-text") }}</b
                  >'ne
                </a>
                {{ $t("help.contact-and-support.here") }}
              </b-alert>

              <b-modal id="modal1" size="lg" scrollable :title="this.$t('help.contact-and-support.enlightenment-modal.title')" title-class="font-18" hide-footer>
                <h3 class="text-center mb-3">
                  TUNESOFT <br />
                  {{ $t("help.contact-and-support.enlightenment-modal.title-1") }}<br />
                  {{ $t("help.contact-and-support.enlightenment-modal.title-1-1") }}
                </h3>

                {{ $t("help.contact-and-support.enlightenment-modal.content-1") }}

                <h5 class="mb-3 mt-4">
                  {{ $t("help.contact-and-support.enlightenment-modal.title-2") }}
                </h5>

                {{ $t("help.contact-and-support.enlightenment-modal.content-2") }}

                <h5 class="mb-3 mt-4">
                  {{ $t("help.contact-and-support.enlightenment-modal.title-3") }}
                </h5>
                {{ $t("help.contact-and-support.enlightenment-modal.content-3") }}

                <h5 class="mb-3 mt-4">
                  {{ $t("help.contact-and-support.enlightenment-modal.title-4") }}
                </h5>
                {{ $t("help.contact-and-support.enlightenment-modal.content-4") }}

                <h5 class="mb-3 mt-4">
                  {{ $t("help.contact-and-support.enlightenment-modal.title-5") }}
                </h5>
                {{ $t("help.contact-and-support.enlightenment-modal.content-5") }}
                <a href="http://www.tunesoft.com.tr/tr/KVKK-Metinlerimiz/KVKK-Metinlerimiz.aspx" target="_blank"></a>
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-1") }}
                <br /><br />
                <b> {{ $t("help.contact-and-support.enlightenment-modal.content-5-2") }}</b
                ><br /><br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-3") }}
                <br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-4") }}
                <br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-5") }}
                <br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-6") }}<br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-7") }}<br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-8") }}<br />

                {{ $t("help.contact-and-support.enlightenment-modal.content-5-9") }}<br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-10") }}
                <br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-11") }}<br />
                {{ $t("help.contact-and-support.enlightenment-modal.content-5-12") }}
              </b-modal>
            </b-form>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  validations: {
    support: {
      firm: { required, minLength: minLength(5), maxLength: maxLength(100) },
      message: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(1000),
      },
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
      email: { required, email },
      phone: {
        required,
        containsOnlyNumbersAndPlus: function(value) {
          return /^[0-9+]+$/.test(value);
        },
      },
    },
  },
  watch: {
    support: {
      deep: true,
      handler() {
        this.$v.support.$touch();
      },
    },
  },
  data() {
    return {
      reference: undefined,
      support: {},
    };
  },
  mounted() {
    this.$v.support.$touch();

    const me = this.currentAccount;

    if (me) {
      this.support.name = me.name;
      this.support.phone = me.phone ? me.phone.split(" ").join("") : null;
      this.support.email = me.credential.email;

      if (this.currentOrganization) {
        this.support.firm = this.currentOrganization.name;
      }
    }

    setTimeout(() => {
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
  methods: {
    async send() {
      try {
        this.$v.support.$touch();

        if (this.$v.support.$error) {
          return;
        }
        const ok = await this.confirm(this.$t("alert.approve-delete"));
        if (!ok) {
          return;
        }
        // const { data } = await HelpClient.Support.create(this.support);
        // this.toast().success(this.$t("alert.success"));
        // this.reference = data.reference;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
